const ApiRoutes = {
  baseUrl: "https://qpay-project-managenent-production.up.railway.app",
  // baseUrl: "http://localhost:3003",
  login: "/employee/login",
  profile: "/employee/profile",
  updateProfile: "/employee/update-profile",
  employeeBirthDay: "/employee/today-birthday",
  assignedProjects: "/employee/assined-projects",
  myProjects: "/employee/my-projects",
  addReport: "/employee/report/add",
  getReport: "/employee/report/list",
  applyLeave: "/leave/apply",
  getLeave: "/leave/list",
  getTasks: "/employee/task/list",
  getPendingTasks: "/employee/task/pending",
  updateTaskStatus: "/employee/task/update-status",
  addProject: "/employee/add-project",
  addModule: "/employee/add-module",
  addAttendance: "/employee/attendance/add",
  getAttendance: "/employee/attendance/list",
  holidayList: "/employee/holiday/list",
  holidaytomarrow: "/employee/holiday/tomarrow",
  todayAttendance: "/employee/attendance/today",
};

export default ApiRoutes;
